"use client";

import { usePageVariantContext } from "@tosize/ui";
import { match } from "ts-pattern";
import { type LinkProps, ShortLink } from "~/components/Link";

interface Item {
	href?: LinkProps["href"];
	title: string;
}

interface Props {
	sheetContent: Item[];
	furnitureContent: Item[];
	defaultContent: Item[];
}

export function ServiceContentSelector(props: Props) {
	const { sheetContent, furnitureContent, defaultContent } = props;
	const { variant } = usePageVariantContext();

	const content = match(variant)
		.with("sheet_material", () => sheetContent)
		.with("tosize_furniture", () => furnitureContent)
		.otherwise(() => defaultContent);

	return content
		?.filter((item) => !!item.href)
		.map((item, index) => <ShortLink key={index} href={item.href} title={item.title} />);
}
